import { FC, ReactNode } from "react";
import Box from "../Box/Box";

import { AccordionProvider } from "./AccordionContext";

interface AccordionProps {
  children: ReactNode;
  id?: string;
}

const Accordion: FC<AccordionProps> = ({ children, id }: AccordionProps) => {
  return (
    <AccordionProvider>
      <Box id={id}>{children}</Box>
    </AccordionProvider>
  );
};

export default Accordion;
